import s from "./style.module.css";
export interface Input {
    count: number;
    onProgress(e: KeyboardEvent | PointerEvent, dir: 1 | -1): void;
}

<div class=s.controls>
    <button
        aria-label="Previous slide"
        onClick(e) {
            input.onProgress(e, -1);
        }>
        <svg viewBox="0 0 20 20" width="20" height="20">
            <path
                d="M 13 2 L 5 10 L 13 18"
                stroke="currentColor"
                stroke-width=2
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"/>
        </svg>
    </button>
    <div
        class=s.indicators
        id="indicators"
        onKeyDown(e) {
            if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
            input.onProgress(e, e.key === "ArrowRight" ? 1 : -1);
        }
        tabindex=0>
        <for|_| from=0 until=input.count>
            <div class=s.indicator data-indicator/>
        </for>
    </div>
    <button
        aria-label="Next slide"
        onClick(e) {
            input.onProgress(e, 1);
        }>
        <svg viewBox="0 0 20 20" width="20" height="20">
            <path
                d="M 7 2 L 15 10 L 7 18"
                stroke="currentColor"
                stroke-width=2
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"/>
        </svg>
    </button>
</div>
